const APP_VERSION = process.env.REACT_APP_VERSION || '0.2.0';

export const getImageUrl = (image) => {
  if (typeof image === 'string') {
    const separator = image.includes('?') ? '&' : '?';
    return `${image}${separator}v=${APP_VERSION}`;
  }
  
  if (image && typeof image === 'object' && 'default' in image) {
    return `${image.default}?v=${APP_VERSION}`;
  }

  return `${image}?v=${APP_VERSION}`;
};

export const getBackgroundImageStyle = (image) => ({
  backgroundImage: `url(${getImageUrl(image)})`,
});
